import _forOwn from "lodash/forOwn";
import * as Yup from "yup";

export const uploadChangeDocumentValidationSchema = Yup.object({
  fileUploads: Yup.object({
    signedUploadChangeDocument: Yup.string().required(
      "Signed upload change document is required"
    ),
  }),
});
